import { Form as AntForm, FormProps } from 'antd'
import { ReactNode, useState } from 'react'
import RequiredMark from '@/shared/components/RequiredMark'

interface Props extends FormProps {
  children?: ReactNode
}

function CustomForm({ children, onFinishFailed, onFinish, ...formProps }: Props) {
  const [validationTrigger, setValidationTrigger] = useState(['onSubmit'])

  return (
    <AntForm
      requiredMark={RequiredMark}
      onFinishFailed={errorInfo => {
        setValidationTrigger(['onChange'])
        onFinishFailed?.(errorInfo)
      }}
      onFinish={values => {
        setValidationTrigger(['onChange'])
        onFinish?.(values)
      }}
      validateTrigger={validationTrigger}
      {...formProps}
    >
      {children}
    </AntForm>
  )
}

export default CustomForm
